import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { DialogComponent } from '@prekog/common-ui';
import { Examination } from '../../../pricelist/examination';
import { AddExaminationDialogResult } from './addexaminationdialogresult';

@Component({
    selector: 'app-addexaminationdialog',
    templateUrl: './addexaminationdialog.component.html',
    styleUrls: ['./addexaminationdialog.component.scss'],
    standalone: true,
    imports: [MatIconModule, ReactiveFormsModule, MatDialogModule, RouterModule, FormsModule, CommonModule]
})
export class AddexaminationDialogComponent extends DialogComponent {
    examination: Examination = {};
    examinationForm?: FormGroup;
    maxPrice: number | null = null;
    @ViewChild('maxPriceInput') maxPriceInput!: ElementRef;
    minPrice: number | null = null;
    @ViewChild('minPriceInput') minPriceInput!: ElementRef;
    price: number | null = null;
    @ViewChild('priceInput') priceInput!: ElementRef;
    regeneroBaseUrl = '';

    showMinMaxPrice = false;

    constructor(
        public router: Router,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _fb: FormBuilder
    ) {
        super()
        this.createExaminationForm();
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }

    createExaminationForm() {
        this.examinationForm = this._fb.group({
            name: ['', [Validators.required]]
        });
    }

    collectExaminationData() {
        this.examination = {
            name: this.examinationForm?.controls['name'].value as string | undefined,
            price: this.price!,
            minPrice: this.minPrice!,
            maxPrice: this.maxPrice!
        };
    }

    addExamination() {
        this.collectExaminationData();
        const addExaminationDialogResult: AddExaminationDialogResult = {
            examination: this.examination
        }
        this.accept(addExaminationDialogResult);
    }

    closeDialog() {
        this.reject();
    }

    onChangePrice() {
        this.price = this.priceInput.nativeElement.value;
    }

    onChangeMinPrice() {
        this.minPrice = this.minPriceInput.nativeElement.value;
    }

    onChangeMaxPrice() {
        this.maxPrice = this.maxPriceInput.nativeElement.value;
    }

    showMaxMinPrices() {
        this.showMinMaxPrice = !this.showMinMaxPrice;
        this.price = null;
    }
    showPrice() {
        this.showMinMaxPrice = !this.showMinMaxPrice;
        this.minPrice = null;
        this.maxPrice = null;
    }
}
